module.exports = __webpack_public_path__ + "8d7d6603ed7add06eccaf48ac04ab6ac.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/iaqaggregatetable/iaqaggregatetablewidgetexample.png
// module id = 797
// module chunks = 7